module.exports = __webpack_public_path__ + "img/promotion.2eaaafb2.jpg";